import { GetQuickJournalNow } from "./Clock/QuickJournalClock";

export function GetLocalDayHourKey(dateText: string): string {
    const date = new Date(dateText);

    if (Number.isNaN(date.getTime())) {
        return "";
    }

    return GetDayHourKey(GetLocalDayKeyFromDate(date), date.getHours());
}

export function GetLocalDayKey(dateText: string): string {
    const date = new Date(dateText);

    if (Number.isNaN(date.getTime())) {
        return "";
    }

    return GetLocalDayKeyFromDate(date);
}

export function GetLocalDayKeyFromDate(date: Date): string {
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, "0");
    const day = `${date.getDate()}`.padStart(2, "0");

    return `${year}-${month}-${day}`;
}

export function GetDayHourKey(dayKey: string, hour: number): string {
    return `${dayKey}_${hour.toString().padStart(2, "0")}`;
}

export function GetDayKeyFromHourKey(hourKey: string): string {
    const dayKey = hourKey.slice(0, 10);

    if (!/^\d{4}-\d{2}-\d{2}$/.test(dayKey)) {
        return "";
    }

    return dayKey;
}

export function GetQuickJournalTodayMidday(): Date {
    const today = GetQuickJournalNow();
    today.setHours(12, 0, 0, 0);
    return today;
}
